import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './index.css';
import { nanoid } from 'nanoid';
import AWS from 'aws-sdk';
import * as constants from '../../config/config';

const s3 = new AWS.S3({
  accessKeyId: constants.awsAccessKey,
  secretAccessKey: constants.awsSecretKey,
});

function OfflinePaymentModal({
  term,
  amount,
  discountAmount,
  offlinePaymentDetails,
  showOfflineModal,
  setShowOfflineModal,
  setOfflinePaymentDetails,
  allValues,
  setAllValues,
}) {
  const [paymentType, setPaymentType] = useState('Cash');
  const [twoThousandsCount, setTwoThousandsCount] = useState(0);
  const [fiveHundredsCount, setFiveHundredsCount] = useState(0);
  const [twoHundredsCount, setTwoHundredsCount] = useState(0);
  const [oneHundredsCount, setOneHundredsCount] = useState(0);
  const [fiftiesCount, setFiftiesCount] = useState(0);
  const [twentiesCount, setTwentiesCount] = useState(0);
  const [tensCount, setTensCount] = useState(0);

  const [denomination, setDenomination] = useState(false);

  const [bankName, setBankName] = useState('');
  const [bankBranch, setBankBranch] = useState('');
  const [ddNumber, setDDNumber] = useState('');
  const [chequeNumber, setChequeNumber] = useState('');
  const [image, setImage] = useState('');

  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [paymentDate, setPaymentDate] = useState('')
  const [paymentTowards, setPaymentTowards] = useState('Tution Fee')
  const [remarks, setRemarks] = useState('')

  const totalAmount = totalAmountPaid
    ? totalAmountPaid
    : 2000 * (twoThousandsCount ? twoThousandsCount : 0) +
      500 * (fiveHundredsCount ? fiveHundredsCount : 0) +
      200 * (twoHundredsCount ? twoHundredsCount : 0) +
      100 * (oneHundredsCount ? oneHundredsCount : 0) +
      50 * (fiftiesCount ? fiftiesCount : 0) +
      20 * (twentiesCount ? twentiesCount : 0) +
      10 * (tensCount ? tensCount : 0);
  console.log('totalAmountPaid', totalAmountPaid);

  const amountToBePaid =
    discountAmount !== '' &&
    discountAmount !== 'Pending' &&
    discountAmount !== 'Rejected' &&
    discountAmount !== 'NA'
      ? discountAmount.split(' ')[0]
      : amount;

  const onChangePaymentType = (event) => {
    console.log('event.target.value', event.target.value);
    setPaymentType(event.target.value);
    setTwoThousandsCount(0);
    setFiveHundredsCount(0);
    setTwoHundredsCount(0);
    setOneHundredsCount(0);
    setFiftiesCount(0);
    setTwentiesCount(0);
    setTensCount(0);
    setImage('');
    setBankName('');
    setBankBranch('');
    setDDNumber('');
    setChequeNumber('');
    setTotalAmountPaid(0);
  };

  const onClickSave = () => {
    term = term.replace(' Status', '');
    let details;
    if(paymentDate === "") return alert('Fill All Fields');

    if (paymentType === 'Cash') {
      if (parseInt(totalAmount) !== parseInt(amountToBePaid)) {
        setAllValues({ ...allValues, [term]: 'Unpaid' });
        return alert(`Total amount and Amount to be paid doesn't match`);
      }
      details = {
        [term]: {
          paymentType,
          amountPaid: parseInt(amountToBePaid),
          denominations: {
            twoThousandsCount,
            fiveHundredsCount,
            twoHundredsCount,
            oneHundredsCount,
            fiftiesCount,
            twentiesCount,
            tensCount,
          },
          paymentDate,
          paymentTowards,
          remarks
        },
      };
    } else if (paymentType === 'DD') {
      if (bankName === '' || bankBranch === '' || ddNumber === '') {
        setAllValues({ ...allValues, [term]: 'Unpaid' });
        return alert('Fill All Fields');
      } else if (image === '') {
        setAllValues({ ...allValues, [term]: 'Unpaid' });
        return alert('Upload Image');
      }
      details = {
        [term]: {
          paymentType,
          amountPaid: parseInt(amountToBePaid),
          DDdetails: { bankName, bankBranch, ddNumber, ddImage: image },
          paymentDate,
          paymentTowards,
          remarks
        },
      };
    } else if (paymentType === 'Cheque') {
      if (bankName === '' || bankBranch === '' || chequeNumber === '') {
        setAllValues({ ...allValues, [term]: 'Unpaid' });
        return alert('Fill All Fields');
      } else if (image === '') {
        setAllValues({ ...allValues, [term]: 'Unpaid' });
        return alert('Upload Image');
      }
      details = {
        [term]: {
          paymentType,
          amountPaid: parseInt(amountToBePaid),
          ChequeDetails: {
            bankName,
            bankBranch,
            chequeNumber,
            chequeImage: image,
          },
          paymentDate,
          paymentTowards,
          remarks
        },
      };
    } else if (
      paymentType === 'UPI' ||
      paymentType === 'Card' ||
      paymentType === 'POS machine'
    ) {
      if (parseInt(totalAmountPaid) !== parseInt(amountToBePaid)) {
        setAllValues({ ...allValues, [term]: 'Unpaid' });
        return alert(`Total amount and Amount to be paid doesn't match`);
      }
      details = {
        [term]: {
          paymentType,
          amountPaid: parseInt(amountToBePaid),
          paymentDate,
          paymentTowards,
          remarks
        },
      };
    }

    const offlineDetails = { ...offlinePaymentDetails, ...details};
    console.log('offlineDetails', offlineDetails);
    setOfflinePaymentDetails(offlineDetails);
    setShowOfflineModal(false);
    setPaymentType('Cash');
    setTotalAmountPaid(0);
    setPaymentTowards('Tution Fee')
    setPaymentDate('')
    setRemarks('')
    setDenomination(false);
  };

  const onClickCancel = () => {
    setShowOfflineModal(false);
    setPaymentType('Cash');
    setTotalAmountPaid(0);
    setPaymentTowards('Tution Fee')
    setRemarks('')
    setDenomination(false);
    setPaymentDate('')
    setAllValues({ ...allValues, [term]: 'Unpaid' });
  };

  const fileUpload = async (file) => {
    // setLoading(true)
    const formData = new FormData();
    formData.append("file", file);
    formData.append("platform", 'svbk/dev');
    const url = 'https://upload.aauti.com/file/Upload';
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });
    let responseJson = await response.json();
    // setLoading(false)
    return responseJson?.result;
  };

  const onChangeInputImage = async (e) => {
    const file = e.target.files[0];
    const url = await fileUpload(file)
    console.log('url', url)
    setImage(url)
  }

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onClickDenomination = () => {
    setDenomination(true);
    setTotalAmountPaid(0);
  };

  const onClickAmount = () => {
    setDenomination(false);
    setTwoThousandsCount(0);
    setFiveHundredsCount(0);
    setTwoHundredsCount(0);
    setOneHundredsCount(0);
    setFiftiesCount(0);
    setTwentiesCount(0);
    setTensCount(0);
  };

  const renderDetails = () => {
    return (
      <div className='mb-2 mt-2'>
        <div className='mb-3'>
          <label className='m-0 mr-1' htmlFor='amount'>
            Enter Amount :
          </label>
          <input
            className='ml-1'
            type='number'
            placeholder='Enter Fee Paid'
            onChange={(event) => {
              if (!isNaN(event.target.value)) {
                setTotalAmountPaid(event.target.value);
              }
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal size='lg' show={showOfflineModal} onHide={onClickCancel} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          {' '}
          <p>Payment Type</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mrgnbtm container'>
          <form>

            <div className='form-group'>
              <label className='control-label' htmlFor='paymentType'>
                Select Type Of Payment
              </label>
              <select
                style={{ backgroundImage: 'none' }}
                onChange={onChangePaymentType}
                className='form-control'
                aria-label='Default select example'
                id='paymentType'
              >
                <option value='Cash'>Cash</option>
                <option value='DD'>DD</option>
                <option value='Cheque'>Cheque</option>
                <option value='UPI'>UPI</option>
                <option value='Card'>Card</option>
                <option value='POS machine'>POS machine</option>
              </select>
            </div>

            {paymentType === 'DD' && (
              <>
                <div className='d-flex justify-content-between'>
                  <h6>Amount : Rs.{amount}/-</h6>
                  <h6>Amount After Discount : Rs.{discountAmount}/-</h6>
                  <h6>
                    Amount To Be Paid : Rs.
                    {discountAmount !== '' &&
                    discountAmount !== 'Pending' &&
                    discountAmount !== 'Rejected' &&
                    discountAmount !== 'NA'
                      ? discountAmount.split(' ')[0]
                      : amount}
                  </h6>
                </div>
                <div className='form-group'>
                  <label className='control-label' htmlFor='bankName'>
                    Bank Name
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    onChange={(e) => {
                      setBankName(e.target.value);
                    }}
                    className='form-control'
                    id='bankName'
                    name='bankName'
                    required
                  />
                  {/* <div className="invalid-feedback d-block">{errors[key]}</div> */}
                </div>

                <div className='form-group'>
                  <label className='control-label' htmlFor='bankBranch'>
                    Bank Branch
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    onChange={(e) => {
                      setBankBranch(e.target.value);
                    }}
                    className='form-control'
                    id='bankBranch'
                    name='bankBranch'
                    required
                  />
                  {/* <div className="invalid-feedback d-block">{errors[key]}</div> */}
                </div>

                <div className='form-group'>
                  <label className='control-label' htmlFor='ddNumber'>
                    DD Number
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    onChange={(e) => {
                      setDDNumber(e.target.value);
                    }}
                    className='form-control'
                    id='ddNumber'
                    name='ddNumber'
                    required
                  />
                  {/* <div className="invalid-feedback d-block">{errors[key]}</div> */}
                </div>

                <div>
                  <input
                    className='inputfile'
                    type='file'
                    id='file'
                    onChange={onChangeInputImage}
                    accept='image/*'
                  />
                  <label htmlFor='file'>Upload DD</label>
                </div>
                {/* <div className="invalid-feedback d-block">{errors[key]}</div> */}
                {image && (
                  <img
                    src={image}
                    style={{ height: '100px', width: '100px' }}
                  />
                )}
              </>
            )}

            {paymentType === 'Cheque' && (
              <>
                <div className='d-flex justify-content-between'>
                  <h6>Amount : Rs.{amount}/-</h6>
                  <h6>Amount After Discount : Rs.{discountAmount}/-</h6>
                  <h6>
                    Amount To Be Paid : Rs.
                    {discountAmount !== '' &&
                    discountAmount !== 'Pending' &&
                    discountAmount !== 'Rejected' &&
                    discountAmount !== 'NA'
                      ? discountAmount.split(' ')[0]
                      : amount}
                  </h6>
                </div>
                <div className='form-group'>
                  <label className='control-label' htmlFor='bankName'>
                    Bank Name
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    onChange={(e) => {
                      setBankName(e.target.value);
                    }}
                    className='form-control'
                    id='bankName'
                    name='bankName'
                    required
                  />
                </div>

                <div className='form-group'>
                  <label className='control-label' htmlFor='bankBranch'>
                    Bank Branch
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    onChange={(e) => {
                      setBankBranch(e.target.value);
                    }}
                    className='form-control'
                    id='bankBranch'
                    name='bankBranch'
                    required
                  />
                </div>

                <div className='form-group'>
                  <label className='control-label' htmlFor='chequeNumber'>
                    Cheque Number
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    onChange={(e) => {
                      setChequeNumber(e.target.value);
                    }}
                    className='form-control'
                    id='chequeNumber'
                    name='chequeNumber'
                    required
                  />
                </div>

                <div>
                  <input
                    className='inputfile'
                    type='file'
                    id='file'
                    onChange={onChangeInputImage}
                    accept='image/*'
                  />
                  <label htmlFor='file'>Upload Cheque</label>
                </div>
                {image && (
                  <img
                    src={image}
                    style={{ height: '100px', width: '100px' }}
                  />
                )}
              </>
            )}

            {paymentType === 'Cash' && (
              <div className='ml-1'>
                <div className='d-flex justify-content-between'>
                  <h6>Amount : Rs.{amount}/-</h6>
                  <h6>Amount After Discount : Rs.{discountAmount}/-</h6>
                  <h6>
                    Amount To Be Paid : Rs.
                    {discountAmount !== '' &&
                    discountAmount !== 'Pending' &&
                    discountAmount !== 'Rejected' &&
                    discountAmount !== 'NA'
                      ? discountAmount.split(' ')[0]
                      : amount}
                  </h6>
                </div>
                {/* <h5>Discounted amount = {amount-(amount * (10/100))} :: {(amount * (10/100))}</h5> */}

                <div className='mb-2 mt-2'>
                  <div className='mb-3'>
                    <input
                      className='mr-1'
                      type='radio'
                      id='amount'
                      checked={!denomination}
                      name='selectType'
                      onClick={onClickAmount}
                    />
                    <label className='m-0 mr-1' htmlFor='amount'>
                      Enter Amount :
                    </label>
                    {!denomination && (
                      <input
                        className='ml-1'
                        type='number'
                        placeholder='Enter Fee Paid'
                        onChange={(event) => {
                          if (!isNaN(event.target.value)) {
                            setTotalAmountPaid(event.target.value);
                          }
                        }}
                      />
                    )}
                  </div>

                  <div className=''>
                    <input
                      className='mr-1'
                      type='radio'
                      id='denomination'
                      checked={denomination}
                      name='selectType'
                      onClick={onClickDenomination}
                    />
                    <label className='m-0' htmlFor='denomination'>
                      Enter Denominations
                    </label>
                    {denomination && (
                      <div className='mt-2'>
                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            2000 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 2000's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setTwoThousandsCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs.{' '}
                            {2000 * (twoThousandsCount ? twoThousandsCount : 0)}
                          </span>
                        </div>

                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            500 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 500's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setFiveHundredsCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs.{' '}
                            {500 * (fiveHundredsCount ? fiveHundredsCount : 0)}
                          </span>
                        </div>

                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            200 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 200's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setTwoHundredsCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs.{' '}
                            {200 * (twoHundredsCount ? twoHundredsCount : 0)}
                          </span>
                        </div>

                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            100 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 100's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setOneHundredsCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs.{' '}
                            {100 * (oneHundredsCount ? oneHundredsCount : 0)}
                          </span>
                        </div>

                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            50 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 50's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setFiftiesCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs.{' '}
                            {50 * (fiftiesCount ? fiftiesCount : 0)}
                          </span>
                        </div>

                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            20 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 20's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setTwentiesCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs.{' '}
                            {20 * (twentiesCount ? twentiesCount : 0)}
                          </span>
                        </div>

                        <div className='d-flex align-items-center mb-2'>
                          <span
                            style={{ width: '10%' }}
                            className='d-flex justify-content-end'
                          >
                            10 X &nbsp;
                          </span>
                          <input
                            type='number'
                            className='denominations-input'
                            placeholder="Enter 10's Count"
                            onChange={(event) => {
                              if (!isNaN(event.target.value)) {
                                setTensCount(event.target.value);
                              }
                            }}
                          />
                          <span className='m-0'>
                            &nbsp; = Rs. {10 * (tensCount ? tensCount : 0)}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <hr />
                <div className='d-flex align-items-center'>
                  {/* <div style={{width:"29%"}} className='d-flex '> */}
                  <h5 className='ml-2'>Total&nbsp;</h5>
                  <h5>=</h5>
                  {/* </div> */}
                  <h5>&nbsp;RS.&nbsp;{totalAmount}</h5>
                </div>
                <hr />
              </div>
            )}

            {paymentType === 'UPI' && renderDetails()}
            {paymentType === 'Card' && renderDetails()}
            {paymentType === 'POS machine' && renderDetails()}

            <div className='form-group'>
              <label className='control-label' htmlFor='paymentDate'>
                Payment Date
              </label>
              <input
                autoComplete='off'
                onkeypress="return false"
                type='date'
                value={paymentDate}
                onChange={(e) => {
                  setPaymentDate(e.target.value);
                }}
                className='form-control'
                id='paymentDate'
                name='paymentDate'
              />
            </div>

            <div className='form-group'>
              <label className='control-label' htmlFor='paymentTowards'>
                Payment Towards
              </label>
              <input
                autoComplete='off'
                type='text'
                value={paymentTowards}
                onChange={(e) => {
                  setPaymentTowards(e.target.value);
                }}
                className='form-control'
                id='paymentTowards'
                name='paymentTowards'
              />
              {/* <div className="invalid-feedback d-block">{errors[key]}</div> */}
            </div>

            <div className='form-group'>
              <label className='control-label' htmlFor='remarks'>
                Remarks
              </label>
              <input
                autoComplete='off'
                type='text'
                value={remarks}
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
                className='form-control'
                id='remarks'
                name='remarks'
              />
              {/* <div className="invalid-feedback d-block">{errors[key]}</div> */}
            </div>

          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          Cancel
        </Button>
        <Button
          variant='primary'
          onClick={() => {
            onClickSave();
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default OfflinePaymentModal;
